// extracted by mini-css-extract-plugin
module.exports = {"Container":"Pill_Container__2-E9I","Set":"Pill_Set__20v8q","Item":"Pill_Item__2G90Z","Active":"Pill_Active__Qot82 undefined shapes_ArrowDown__3BQkF shapes_ArrowCommon__1xvfC"};